import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDAO } from './baseDAO';
import { Payout } from 'anchor-shared/lib/model/entity/payout';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { Paystub } from 'anchor-shared/lib/model/entity/paystub';

export class PaystubDAO extends BaseDAO<Paystub> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.PAYSTUB);
  }

  createAndUploadPaystubPDF(
    userId: number,
    payouts: Payout[],
  ): Observable<any> {
    const partialPaystub = {
      userId: userId,
      payouts: payouts,
      createdAt: moment(),
    };
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/createPaystubPdf';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Paystub>(
      url,
      method,
      null,
      partialPaystub,
      headers,
    );
  }

  createPaystub(payouts: Payout[], userId: number): Observable<any> {
    const partialPaystub = {
      userId: userId,
      payouts: payouts,
      createdAt: moment(),
    };
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/createPaystub';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Paystub>(
      url,
      method,
      null,
      partialPaystub,
      headers,
    );
  }

  public updateFromPartial(
    paystubId: number,
    partialPaystub: Partial<Paystub>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/partial/' +
      paystubId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Paystub[]>(
      url,
      method,
      null,
      partialPaystub,
      headers,
    );
  }

  public getPaystubsByUserId() {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/partial';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<Paystub[]>(url, method, null, null, headers);
  }

  public getPaystubsPDF(pdfId: number) {
    let body = {
      id: pdfId,
    };
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/partial/get-signed';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, body, headers);
  }
}
